import React, { Component, useState } from "react";
import { Flip, ToastContainer, toast } from "react-toastify";
import { getTokenContract } from "../../services/contract";
import {tokenAddress} from '../../services/tokenContract'

const Header = (props) => {

  const toggleSideBar = () => {
    if (props.sideBarToggle) {
      props.sideBarToggle();
    }
  };

  const addUsdtToMetamask = async () => {
    try {
      // wasAdded is a boolean. Like any RPC method, an error may be thrown.
      const wasAdded = await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20", // Initially only supports ERC20, but eventually more!
          options: {
            address: tokenAddress, // The address that the token is at.
            // address: '0xD6bdfA86136F8390C8513d27C2578fE7e54C89d8', // The address that the token is at.
            symbol: "USDT", // A ticker symbol or shorthand, up to 5 chars.
            decimals: 6, // The number of decimals in the token
            //   image: tokenImage, // A string url of the token logo
          },
        },
      });

      if (wasAdded) {
        console.log("Thanks for your interest!");
      } else {
        console.log("Your loss!");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const notify = (message) =>
    toast.warn(message, {
      position: toast.POSITION.TOP_LEFT,
      delay: "20000",
      style: { zIndex: "2" },
      transition: Flip,
      autoClose: 10000,
    });

    return (
      <div
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        className={"fixed top-0 left-1/2 -translate-x-1/2 flex justify-center w-full px-10  lg:p-0 lg:max-h-screen z-999999 "}
      >
        <div
          style={{
            background: " rgba(0, 15, 112, 0.25)",
            boxShadow: "0 8px 32px 0 rgba(58, 67, 159, 0.37)",
            backdropFilter: "blur(4px)",
            webkitBackdropFilter: "blur(4px)",
            borderRadius: "10px",
            border: "1px solid rgba(255, 255, 255, 0.18)",
          }}
          className="flex justify-between items-center rounded-mini max-w-desktop-preview-bar w-full px-5 py-2 shadow-preview-bar lg:pl-10 sm:pl-5 lg:py-2.5 lg:rounded-none lg:rounded-b-mini lg:pr-0 false"
        >
          <div className="flex w-full overflow-hidden items-center justify-between space-x-2.5 lg:items-start ">
            <div className="w-full flex justify-start items-center space-x-5 lg:flex-col lg:h-full lg:items-start lg:space-x-0 lg:space-y-7.5">
                <div className="flex items-center  false lg:w-full lg:pr-10 sm:pr-5">
                  <a
                    href="/"
                    className="header-link"
                    style={{ marginRight: "95px" }}
                  >
                    <img
                      style={{ width: "50px", height: "50px" }}
                      src="/logo/logo.gif"
                      className="light"
                       alt=""
                    />
                    <img
                      style={{ width: "50px", height: "50px" }}
                      src="/logo/logo.gif"
                      className="dark"
                      alt=""
                    />
                  </a>
                </div>
            </div>
            {!props.signer ? (
                  <button
                    className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-3 bg-main-bg hover:bg-black-500 whitespace-nowrap lg:hidden"
                    onClick={props.onConnectWallet}
                    id="connectWallet"
                  >
                    Connect wallet
                  </button>
                ) : (
                  <div className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-2.5 hover:bg-line-gray active:bg-active-gray text-white font-normal rounded items-center">
                    {props.userAddress != ""
                      ? props.userAddress.slice(0, 4) +
                        "..." +
                        props.userAddress.slice(
                          props.userAddress.length - 4,
                          props.userAddress.length
                        )
                      : ""}
                  </div>
                )}
          </div>
          <div className="flex lg:justify-end lg:ml-auto lg:pr-10 sm:pr-5">
          {props.signer && (
            <button
              onClick={props.onDisconnect}
              className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-3 bg-white-100 hover:bg-white-300 rounded-full w-10 h-10 !p-0 ml-5"
            >
              <svg
                className="w-6 h-6 cursor-pointer"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6 6 18M6 6l12 12"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
          )}
            {!props.isHome && (
              <div className="">
                <button
                  onClick={toggleSideBar}
                  className="mobile-menu-button flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-3 bg-white-100 hover:bg-white-300 flex-col rounded-full w-10 h-10 !p-0 hidden lg:flex"
                >
                  <span className="w-4 border-t border-white mb-2"></span>
                  <span className="w-4 border-t border-white"></span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

export default Header;
